export const defaultError =
  "We're sorry, something went wrong. " +
  'Please try again or contact support if the issue persists.';
